import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Image } from 'primereact/image'
import { Button } from 'primereact/button'
import { UserVerifyPhoto } from '../../../../../../common/types/user'
import { useFetchV2 } from '../../../../_core/hooks'
import { approveVerifyPhotos,denyVerifyPhotos,getUserVerifyPhotos } from '../../../../../../common/_services/admin.service'
import Await from '../../../../_core/components/await'

interface photoReviewProps {
  openProfile: (id:string) => void
}

const VerifyReview: React.FC<photoReviewProps> = (props:photoReviewProps) => {
  const [photos,reload] = useFetchV2<UserVerifyPhoto[],undefined>(getUserVerifyPhotos,undefined,[])
  return (
    <Await dependency={photos}>{(photos) =>
      <div className="p-3">
          <DataTable
            value={photos}
          >
              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
              <Column
                bodyClassName={(y,_) =>  y.sort === 1 ? 'first-photo' : ''}
                field="photo"
                header="Photo"
                style={{ 'width':'200px' }}
                body={(x,_) => <Image onClick={() => props.openProfile(x.userId)} src={x.imgUrl} alt="Image" width="300px" className="shadow-4" />}>
              </Column>
              <Column
                field="name"
                header="Verify Photo"
                body={(x,_) =>
                  <div className="d-flex h-100">
                    <Image src={x.verify_photo_url} alt="Image" width="450" />
                  </div>
                }>
              </Column>
              <Column field="id"
                header="Action"
                body={(x,_) =>
                  <>
                    <Button label="Deny" className="btn btn-secondary" onClick={async () => denyVerifyPhotos(x.userId,x.imgUrl,reload,reload)}/>
                    <Button label="Approve" className="btn btn-primary mx-2" onClick={async () => approveVerifyPhotos(x.userId,x.imgUrl,reload,reload)}/>
                  </>
                }>
              </Column>
          </DataTable>
      </div>
    }</Await>
  )
}

export default VerifyReview
